import React, { useState, useEffect } from "react";
import './classes/ScoutSidebar.css';
import { configData } from "../config";
import { useNavigate,useParams,useLocation } from 'react-router-dom';


const ScoutSidebar = ({ userEmail, userId}) => {
  const [loading, setLoading] = useState(false);
    
    const[scoutNews, setScoutNews] = useState({});

    const app_url = configData.APP_URL;
  const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
async function getscoutnews() {
        
           
                const response = await fetch(
                     app_url+'smwwscout/getscoutnews',
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                   setScoutNews(responsedata.data.result);
                } 
                
           
        }
  
    useEffect(() => {   

    const handler = setTimeout(() => {
     // fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  });
useEffect(() => {   

    Promise.all([
                      getscoutnews()
                  ])
                  .then(() => {
               
                  
                  })
  }, []);
  
  const location = useLocation();
  const path = location.pathname;

  const ItemToShowinViewTab = path.includes('/users/') || path.includes('/user/');

  

    return(
        
        <div className="scout-right">
            <div id="sidebar-third" className="scout-grid_4">
                <div className="scout-region scout-region-sidebar-third">
                    <div id="block-smww-smww-operations" className="scout-block agent-block-smww"></div>
                       
                            <h1>Quick Links</h1>
                           <ul className="user-opt-menu">
                            <li><a href={`/user/${loggedin_drupal_uid}`}>Dashboard Home</a></li>
                            <li><a href="/node/add/scout-report">Upload a new report</a></li>
                            <li><a href="/my_reports">My reports</a></li>
                            <li><a href="/my_scout_request_reports">My Scout Request reports</a></li>
                            <li><a href="/scouts-directory">Scouts Directory</a></li>
                            <li><a href="/admin/reports/scouting_request">View Scouting Requests</a></li> 
                            <li><a href="/resource_library">Resource Library</a></li>
                            <li><a href={`/user/${loggedin_drupal_uid}/edit`}>Manage My Public Profile</a></li>
                            <li><a href="/my_scouts_account">My Account</a></li>
                          </ul>
                            <a style={{color:"#fff"}} href="https://smww.zoom.us/j/804154184" rel="nofollow" class="form-submit" target="_blank">Sunday Chat Link</a>  
                          <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                            <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                            <li style={{paddingLeft: "0px"}}>
                              <a href="/smww_pay">
                                <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                              </a>
                            </li>
                          </ul>  
                          {ItemToShowinViewTab && (                                
                            <>
                              {scoutNews.length > 0 && (
                              <div className="scout-news-container">
                                <h3>Scout News</h3>
                                  {scoutNews.map((sctnews, index)=> ( 
                                    <div key={index}>       
                                      <ul>
                                          <li style={{border: "1px solid #000", margin: "0 0 12px 21px"}}>
                                            <div style={{background: "#cde", padding: "5px", fontWeight: "700"}}>
                                              <a href={sctnews.url}>{sctnews.head}</a>
                                            </div>
                                            <div style={{background: "#fff", padding: "5px"}}><div dangerouslySetInnerHTML={{ __html: sctnews.body }} /></div>
                                          </li>
                                      </ul>
                                    </div>
                                  ))}
                              </div>
                              )}
                            </> 
                          )}      
                </div>
            </div>
        </div>
        
    );
};

export default ScoutSidebar;